import 'hammerjs';
import 'moment/min/locales';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { LayoutModule } from './layout/layout.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { EnvConfigurationService } from './shared/services/envconf/envconf.service';
import { HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';

// import packageJson from '../../package.json';
import { ObservabilityModule } from '@michelin/observability';
import { MatNativeDateModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DATE_FORMATS } from './shared/utils/constants';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.messages.json');
}

@NgModule({
  imports: [
    BrowserAnimationsModule,
    LayoutModule,
    AppRoutingModule,
    MatMomentDateModule,
    MatNativeDateModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ObservabilityModule.forRoot({
      app: {
        name: 'front6cd',
        version: '1.0.0',
        environment: EnvConfigurationService.getEnv()
      }
    })
  ],
  declarations: [AppComponent],
  providers: [
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([authInterceptor])),
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }, // Define o idioma
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS }, // Aplica os formatos customizados
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } }
  ],
  exports: [TranslateModule],
  bootstrap: [AppComponent]
})
export class AppModule {}
